import { useIntl } from 'react-intl';

export function Tr() {
  const intl = useIntl();
  return (id: string) => intl.formatMessage({ id, defaultMessage: id });
}